import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { EventWizardData } from 'stores/events/creation-wizard-store';

interface CommentsStepMobileProps extends WithTranslation {
  wizardData: EventWizardData;
  onValueChanged: (...changes: [string, string][]) => void;
}

interface MobileCommentsStepState {
  wizardData: EventWizardData;
  titleFocused: boolean;
}

class MobileCommentsStep extends Component<CommentsStepMobileProps, MobileCommentsStepState> {
  constructor(props) {
    super(props);

    this.state = {
      wizardData: props.wizardData,
      titleFocused: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: CommentsStepMobileProps) {
    if (nextProps && nextProps !== this.props) {
      this.setState({
        wizardData: nextProps.wizardData
      });
    }
  }

  componentDidMount() {
    const current = this.state.wizardData;

    let compoundTitle = '';
    compoundTitle =
      (current?.eventTitle ?? '').length <= 0
        ? `${current.eventType.name}`.trim()
        : `${current?.eventTitle ?? ''} / ${current.eventType.name}`.trim();

    this.onManuallyChangeTitle(compoundTitle);
  }

  private handleValue = (property: string, value: any) => {
    const { wizardData } = this.state;
    wizardData[property] = value;
    this.setState(
      {
        wizardData
      },
      () => this.props.onValueChanged([property, value])
    );
  };

  private onManuallyChangeTitle = (val: string) => {
    const current = this.state.wizardData.eventTitle;
    if (current !== val) {
      const modifiedWizardData = this.state.wizardData;
      modifiedWizardData.eventTitle = val;
      this.setState(
        {
          wizardData: modifiedWizardData
        },
        () => this.props.onValueChanged(['eventTitle', val])
      );
    }
  };

  render() {
    const { t } = this.props as any;
    const { wizardData, titleFocused } = this.state;

    return (
      <form className="space-y-6 p-4 sm:p-6">
        {/* Event Title */}
        <div className="flex flex-col">
          <label className="mb-2 text-sm font-medium text-gray-700">{t('Event Title')}</label>
          <input
            type="text"
            value={wizardData.eventTitle}
            onChange={e => this.onManuallyChangeTitle(e.target.value)}
            onFocus={() => this.setState({ titleFocused: true })}
            onBlur={() => this.setState({ titleFocused: false })}
            className={`border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-600 transition ${
              titleFocused ? 'border-primary-600' : 'border-gray-300'
            }`}
            placeholder={t('Enter event title')}
          />
        </div>

        {/* Comments */}
        <div className="flex flex-col">
          <label className="mb-2 text-sm font-medium text-gray-700">{t('Comments')}</label>
          <textarea
            value={wizardData.comments || ''}
            onChange={e => this.handleValue('comments', e.target.value)}
            className="border rounded px-3 py-2 resize-none min-h-[30vh] max-h-[30vh] focus:outline-none focus:ring-2 focus:ring-primary-600 transition"
            placeholder={t('Add any comments')}
          />
        </div>
      </form>
    );
  }
}

export default withTranslation()(MobileCommentsStep);
